<template>
    <div>
        <div v-if="sumReportData" class="col-md-12 col-lg-12 revenue-report">
            <h2>Summary</h2>
            <div class="table-responsive">
                <table class="table table-striped table-hover" style="margin-bottom: 10px">
                    <tbody>
                    <tr>
                        <th>{{reportMonths[0]}}</th>
                        <th>{{reportMonths[1]}}</th>
                        <th>Increase</th>
                        <th>Decrease</th>
                        <th>Sum</th>
                    </tr>
                    <tr>
                        <td>{{usNum(sumReportData.netInvoice[0])}}</td>
                        <td>{{usNum(sumReportData.netInvoice[1])}}</td>
                        <td>{{usNum(sumReportData.increase)}}</td>
                        <td>{{usNum(sumReportData.decrease)}}</td>
                        <td>{{usNum(sumReportData.change)}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-right" style="margin-bottom: 10px">
                <span v-on:click="isSummaryCollapsed = !isSummaryCollapsed" :class="['glyphicon', isSummaryCollapsed ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up']"></span> Employers changes
            </div>
            <div class="table-responsive">
                <table v-show="!isSummaryCollapsed" class="table table-striped table-hover">
                    <tbody>
                       <tr>
                            <td>Added</td>
                            <td>{{sumReportData.added.join(', ')}}</td>
                        </tr>
                        <tr>
                            <td>Increased</td>
                            <td>{{sumReportData.increased.join(', ')}}</td>
                        </tr>
                        <tr>
                            <td>Removed</td>
                            <td>{{sumReportData.removed.join(', ')}}</td>
                        </tr>
                        <tr>
                            <td>Decreased</td>
                            <td>{{sumReportData.decreased.join(', ')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-md-12 col-lg-12 revenue-report">
            <div>
                <div style="display: flex; justify-content: space-between">
                    <h2>Details</h2>
                    <div class="text-right detail-control-panel">
                        <button v-on:click="setCollapsedForAll(false)" class="btn">Expand all</button>
                        <button v-on:click="setCollapsedForAll(true )" class="btn">Collapse all</button>
                        <button v-on:click="exportToCSV()" class="btn">Export to CSV</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover">
                        <tbody>
                            <tr>
                                <th colspan="8"><h2>{{reportMonths[0]}}</h2></th>

                                <th colspan="8" class="separator"><h2>{{reportMonths[1]}}</h2></th>
                            </tr>
                            <tr>
                                <th style="max-width:100px">Company ID</th>
                                <th>Employer</th>
                                <th></th>
                                <th>Period</th>
                                <th>Budget</th>
                                <th>Gross spend</th>
                                <th>Billable amount</th>
                                <th>Net Invoice</th>
                                <th class="separator">Period</th>
                                <th>Budget</th>
                                <th>Gross spend</th>
                                <th>Billable amount</th>
                                <th>Net Invoice</th>
                                <th>Increases</th>
                                <th>Decreases</th>
                                <th></th>
                            </tr>
                            <template v-for="(statusGroup) in groupedData">
                                <tr class="statusGroupHeadline">
                                    <th colspan="5">
                                        <span v-on:click="statusGroup.collapsed = !statusGroup.collapsed"
                                              :class="['glyphicon', statusGroup.collapsed ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up']"></span>
                                        {{statusGroup.groupName}}
                                    </th>
                                    <th class="text-right">{{usNum(statusGroup.sum[0].currentCost)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.sum[0].billableAmount)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.sum[0].netInvoice)}}</th>
                                    <th class="separator" colspan="2"></th>
                                    <th class="text-right">{{usNum(statusGroup.sum[1].currentCost)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.sum[1].billableAmount)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.sum[1].netInvoice)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.incomeIncrease)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.incomeDecrease)}}</th>
                                    <th> </th>
                                </tr>
                                <template v-if="!statusGroup.collapsed" v-for="(agencyGroup) in statusGroup.data">
                                    <tr class="agencyGroupHeadline">
                                        <th colspan="5">
                                            <span v-on:click="agencyGroup.collapsed = !agencyGroup.collapsed"
                                                  :class="['glyphicon', agencyGroup.collapsed ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up']"></span>
                                            {{agencyGroup.groupName}}
                                        </th>
                                        <th class="text-right">{{usNum(agencyGroup.sum[0].currentCost)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.sum[0].billableAmount)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.sum[0].netInvoice)}}</th>
                                        <th class="separator" colspan="2"></th>
                                        <th class="text-right">{{usNum(agencyGroup.sum[1].currentCost)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.sum[1].billableAmount)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.sum[1].netInvoice)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.incomeIncrease)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.incomeDecrease)}}</th>
                                        <th> </th>
                                    </tr>
                                    <tr v-if="!agencyGroup.collapsed" v-for="bp in agencyGroup.data">
                                        <td style="text-align:right">{{getRecordValue(bp, 'employerId')}}</td>
                                        <td><div class="truncate" style="width: 200px" :title="getRecordValue(bp, 'employerName')">{{getRecordValue(bp, 'employerName')}}</div></td>
                                        <td class="text-center">
                                            <i v-if="getEmployerStatus(bp) == 'lost'" class="fa fa-minus-circle red"></i>
                                            <i v-else-if="getEmployerStatus(bp) == 'new'" class="fa fa-plus-circle green"></i>
                                        </td>
                                        <td>{{getPeriod(bp[0])}}</td>
                                        <td class="text-right">{{getBudget(bp[0])}}</td>
                                        <td class="text-right">{{usNum(getBPValue(bp[0], 'currentCost'))}}</td>
                                        <td class="text-right">{{usNum(getBPValue(bp[0], 'billableAmount'))}}</td>
                                        <td class="text-right">{{usNum(getBPValue(bp[0], 'netInvoice'))}}</td>
                                        <td class="separator">{{getPeriod(bp[1])}}</td>
                                        <td class="text-right">{{getBudget(bp[1])}}</td>
                                        <td class="text-right">{{usNum(getBPValue(bp[1], 'currentCost'))}}</td>
                                        <td class="text-right">{{usNum(getBPValue(bp[1], 'billableAmount'))}}</td>
                                        <td class="text-right">{{usNum(getBPValue(bp[1], 'netInvoice'))}}</td>
                                        <td class="text-right">{{ usNum(bp.incomeIncrease)}}</td>
                                        <td class="text-right">{{ usNum(bp.incomeDecrease)}}</td>
                                        <td>
                                            <i v-if="bp.incomeDecrease < 0" class="fa fa-arrow-down red"></i>
                                            <i v-else-if="bp.incomeIncrease > 0" class="fa fa-arrow-up green"></i>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="sumReportData" class="col-md-12 col-lg-12 revenue-report">
            <h2>Budget addons</h2>
            <div class="table-responsive">
                <table class="table table-striped table-hover" style="margin-bottom: 10px">
                    <tbody>
                    <tr>
                        <th colspan="3" style="width: 50%"><h2>{{reportMonths[0]}}</h2></th>
                        <th colspan="2" class="separator"><h2>{{reportMonths[1]}}</h2></th>
                    </tr>
                    <tr>
                        <th>Employer</th>
                        <th>Name</th>
                        <th>Cost</th>
                        <th class="separator">Name</th>
                        <th>Cost</th>
                    </tr>
                    <tr v-for="ba in billingAddons">
                        <td>{{getBPValue(ba[0], 'employerName')}}</td>
                        <td>{{getBPValue(ba[0], 'billingAddonName')}}</td>
                        <td>{{usNum(getBPValue(ba[0], 'billingAddonCost'))}}</td>
                        <td class="separator">{{getBPValue(ba[1], 'billingAddonName')}}</td>
                        <td>{{usNum(getBPValue(ba[1], 'billingAddonCost'))}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'reportData', 'reportMonths', 'dateFrom','salesmenList', 'filters'
        ],
        data() {
            return {
                csrfToken:  window.Laravel.csrfToken,
                groupedData: null,
                formattedData: null,
                sortedBy: null,
                sumReportData: null,
                isSummaryCollapsed: true,
                billingAddons: null
            };
        },
        methods: {
            exportToCSV(){
                const rows = [['Company ID', 'Employer', 'Status', 'Trial', 'Agency', 'Period', 'Budget', 'Gross spend', 'Billable Amount', 'Net Invoice',"Period", "Budget", 'Gross spend', 'Billable Amount', 'Net Invoice', 'Increases', 'Decreases']];
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += rows.join(",") + "\r\n";
                _.forEach(this.formattedData, bp => {
                    var rowArray = [
                        this.getRecordValue(bp, 'employerId'),
                        this.getRecordValue(bp, 'employerName').replace(/,/g, ''),
                        this.getRecordValue(bp, 'status'),
                        this.getRecordValue(bp, 'trial'),
                        this.getRecordValue(bp, 'agencyName'),
                        this.getPeriod(bp[0]),
                        this.getBudget(bp[0], false),
                        bp[0] ? bp[0].currentCost : null,
                        bp[0] ? bp[0].billableAmount : null,
                        bp[0] ? bp[0].netInvoice : null,
                        this.getPeriod(bp[1]),
                        this.getBudget(bp[1], false),
                        bp[1] ? bp[1].currentCost : null,
                        bp[1] ? bp[1].billableAmount : null,
                        bp[1] ? bp[1].netInvoice : null,
                        bp.incomeIncrease || 0,
                        bp.incomeDecrease || 0
                    ];
                    var row = rowArray.join(",");
                    csvContent += row + "\r\n";
                });
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', 'boardRevenue.csv');
                document.body.appendChild(link); // Required for FF
                link.click();
                document.body.removeChild(link);
            },
            setCollapsedForAll(isCollapsed){
                _.forEach(this.groupedData, groups => {
                    groups.collapsed = isCollapsed;
                    _.forEach(groups.data, group => {
                        group.collapsed = isCollapsed;
                    });
                });
            },
            getNetInvoiceSum(i){
                return _.sumBy(_.map(this.reportData, (r) => {
                    return r['sum'][i] ? (r['sum'][i].netInvoiceOrBillable || 0) : 0;
                }), (r) => { return parseFloat(r); });
            },
            getBPValue(bp, key, formatNumber = false){
                var result = bp ? bp[key] : null;
                return formatNumber ? this.usNum(result) : result;
            },
            getEmployerStatus(bp){
                if(bp[0] && bp[1]){
                    return null;
                }
                if(bp[0] && !bp[1]){
                    return 'new';
                }
                if(!bp[0] && bp[1]){
                    return 'lost';
                }
                return 'error';
            },
            getIncomeChange(bp){
                if(!bp){
                    return null;
                }
                var leftNetInvoice = parseFloat(this.getBPValue(bp[0], 'netInvoiceOrBillable')) || 0;
                var rightNetInvoice = parseFloat(this.getBPValue(bp[1], 'netInvoiceOrBillable')) || 0;
                return leftNetInvoice - rightNetInvoice;
            },
            getPeriod(bp){
                if(!bp){
                    return null;
                }
                return bp.from + ' - ' + bp.to;
            },
            getBudget(bp, formatted = true){
                if(!bp){
                    return null;
                }
                var budget =  bp.budget == 999999.00 ? 'Unlimited' : bp.budget;
                return formatted ? this.usNum(budget) : budget;
            },
            getRecordValue(record, key){
                if(!record){
                    return null;
                }
                return record[0] ? record[0][key] : record[1][key];
            },
            usNum(number){
                if(!number){
                    return null;
                }
                return Math.round(parseFloat(number) || 0).toLocaleString('US');
            },
            createDataForSummary(){
                var sumReportData = {
                    netInvoice: [this.getNetInvoiceSum(0), this.getNetInvoiceSum(1)],
                    added: [],
                    removed: [],
                    increased:[],
                    decreased: []
                };

                sumReportData.increase = 0;
                sumReportData.decrease = 0;
                _.forEach(this.formattedData, bp => {
                    var ch = this.getIncomeChange(bp);
                    if(ch > 0) {
                        sumReportData.increase += ch || 0;
                    }
                    else {
                        sumReportData.decrease += ch || 0;
                    }
                    if(bp[0] && !bp[1]){
                        sumReportData.added.push(bp[0].employerName)
                    }
                    else if(!bp[0] && bp[1]){
                        sumReportData.removed.push(bp[1].employerName)
                    }
                    else{
                        if(ch > 0) {
                            sumReportData.increased.push(bp[0].employerName)
                        }
                        else if(ch < 0) {
                            sumReportData.decreased.push(bp[0].employerName)
                        }
                    }
                });
                sumReportData.change = sumReportData.increase + sumReportData.decrease;
                sumReportData.added = _.sortBy(sumReportData.added);
                sumReportData.removed = _.sortBy(sumReportData.removed);
                sumReportData.increased = _.sortBy(sumReportData.increased);
                sumReportData.decreased = _.sortBy(sumReportData.decreased);
                return sumReportData;
            },
            createBudgetEmployerAddonsData(sourceData){
                var billingAddon = [];
                _.forEach(sourceData, bp => {
                    if(this.getRecordValue(bp, 'billingAddonName')){
                        billingAddon.push([bp[0], bp[1]]);
                    }
                });
                return billingAddon;
            }
        },
        mounted: function(){
            this.groupedData = _.cloneDeep(this.reportData);

            this.formattedData = _.sortBy(_.flatMapDeep(this.reportData, (statuses) => {
              return _.flatMapDeep(statuses.data, (agencies) => {
                return agencies.data;
              });
            }), (o) => {
              return o[0] ? o[0].agencyName + o[0].employerName : o[1].agencyName + o[1].employerName;
            });

            this.sumReportData = this.createDataForSummary();
            this.billingAddons = this.createBudgetEmployerAddonsData(this.formattedData);
        }
    }
</script>

<style scoped>
.revenue-report {
    align-items: stretch;
    margin-top: 20px;
}

.revenue-report .separator {
    border-left: 2px solid slategray;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.revenue-report .red {
    color: red;
}
.revenue-report .green {
    color: green;
}

.revenue-report th {

}

.revenue-report .detail-control-panel {
    margin: 0 0 20px 0;
}

.revenue-report .statusGroupHeadline th {
    background: lightblue;
    font-size: 18px;
}

.revenue-report .agencyGroupHeadline th {
    background: lightcyan;
    font-size: 15px;
    padding-left: 30px;

}
</style>